import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function RoomStatusOverview({ data }) {
    const navigate = useNavigate();

    // Extract actual API data with zero-safe defaults
    const vacant = data?.vacant !== undefined && data?.vacant !== null ? Number(data.vacant) : 0;
    const occupied = data?.occupied !== undefined && data?.occupied !== null ? Number(data.occupied) : 0;
    const clean = data?.clean !== undefined && data?.clean !== null ? Number(data.clean) : 0;
    const maint = (Number(data?.repair) || 0) + (Number(data?.ooo) || 0);
    const total = data?.total !== undefined && data?.total !== null ? Number(data.total) : 0;

    return (
        <Card 
            onClick={() => navigate('/room-management')}
            sx={{ 
                borderRadius: 3, 
                boxShadow: '0 1px 3px rgba(0,0,0,0.04)', 
                border: '1px solid #f1f5f9',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                cursor: 'pointer',
                transition: 'box-shadow 0.2s',
                '&:hover': { boxShadow: '0 4px 12px rgba(0,0,0,0.06)' }
            }}
        >
            <CardContent sx={{ p: 2.5, '&:last-child': { pb: 2.5 } }}>
                {/* Top Label */}
                <Box sx={{ mb: 1.5 }}>
                    <Typography 
                        variant="caption" 
                        sx={{ 
                            fontWeight: 700, 
                            letterSpacing: '0.06em', 
                            color: '#94a3b8', 
                            textTransform: 'uppercase',
                            fontSize: '0.72rem'
                        }}
                    >
                        ROOM INVENTORY
                    </Typography>
                </Box>

                {/* Main Value, Ready to sell, & Total Keys */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', mb: 2.5 }}>
                    <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
                        <Typography variant="h4" sx={{ fontWeight: 800, color: '#0f172a', lineHeight: 1.1, fontSize: '1.85rem' }}>
                            {vacant}
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#16a34a', fontWeight: 600, fontSize: '0.78rem' }}>
                            Ready to sell
                        </Typography>
                    </Box>
                    <Typography variant="body2" sx={{ color: '#94a3b8', fontSize: '0.78rem' }}>
                        {total} Total Keys
                    </Typography>
                </Box>

                {/* Bottom Row: 4 Mini Stats */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', pt: 0.5 }}>
                    <Box>
                        <Typography variant="caption" sx={{ color: '#94a3b8', fontSize: '0.72rem', display: 'block' }}>
                            Vacant
                        </Typography>
                        <Typography variant="body2" sx={{ fontWeight: 800, color: '#0f172a', fontSize: '0.92rem' }}>
                            {vacant}
                        </Typography>
                    </Box>
                    <Box>
                        <Typography variant="caption" sx={{ color: '#94a3b8', fontSize: '0.72rem', display: 'block' }}>
                            Occupied
                        </Typography>
                        <Typography variant="body2" sx={{ fontWeight: 800, color: '#0f172a', fontSize: '0.92rem' }}>
                            {occupied}
                        </Typography>
                    </Box>
                    <Box>
                        <Typography variant="caption" sx={{ color: '#94a3b8', fontSize: '0.72rem', display: 'block' }}>
                            Clean
                        </Typography>
                        <Typography variant="body2" sx={{ fontWeight: 800, color: '#0f172a', fontSize: '0.92rem' }}>
                            {clean}
                        </Typography>
                    </Box>
                    <Box>
                        <Typography variant="caption" sx={{ color: '#94a3b8', fontSize: '0.72rem', display: 'block' }}>
                            Maint.
                        </Typography>
                        <Typography variant="body2" sx={{ fontWeight: 800, color: '#0f172a', fontSize: '0.92rem' }}>
                            {maint}
                        </Typography>
                    </Box>
                </Box>
            </CardContent>
        </Card>
    );
}
